import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForExploreEditionBenefitsModalWithoutPDE({
	product,
	edition,
	isInTrial,
	invoiceableStatus,
	canAddPaymentDetails,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		isInTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-customer-service']) &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails
	) {
		return true;
	}

	return false;
}
